import LOGIN_CONST from '../Login/const';

const Const = {
    [LOGIN_CONST.LOGIN_SEND_REQUEST]: LOGIN_CONST.LOGIN_SEND_REQUEST,
    RETURNADO_LOGOUT: 'RETURNADO_LOGOUT',
    RETURNADO_SET_CURRENT_PAGE_TITLE: 'RETURNADO_SET_CURRENT_PAGE_TITLE',
};

export default Const;